export const CLINIC = {
  logo: "/images/kprc-logo.png",
  name: "Kamana Physiotherapy & Rehab Center",
  shortName: "Kamana Rehab",
  tagline: "Reclaim Your Life",
  phone: "+91 92508 23508",
  phoneHref: "tel:+919250823508",
  whatsapp:
    "https://wa.me/919250823508?text=Hello%20Dr.%20Vipul%20Singh%2C%20I%20would%20like%20to%20book%20a%20physiotherapy%20consultation.",
  email: "kprc2025@gmail.com",
  address:
    "Gate No. 3, 3/180A, Railway Station Rd, opposite T.D. Girls Inter College, Vidhayak Puram, Vinay Khand 3, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
  addressShort: "Vinay Khand 3, Gomti Nagar, Lucknow",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Kamana+Physiotherapy+%26+Rehab+Center+Gomti+Nagar+Lucknow",
  hours: [
    { d: "Mon – Sat", t: "9:00 AM – 9:00 PM" },
    { d: "Sunday", t: "9:00 AM – 1:00 PM" },
  ],
};

export const DOCTOR = {
  name: "Dr. Vipul Singh",
  title: "Chief Consultant Physiotherapist",
  quals: "DPT · BPT · MPT · CDNT · CEOMT",
  honor: "University Gold Medalist in Physiotherapy",
  creds: ["Certified Chiropractor & Manual Physiotherapist", "Ex. Safderjung, New Delhi NCR"],
  intro:
    "Dr. Vipul Singh has helped hundreds of patients recover from pain, injuries and long-term physical problems with care, patience and clinical precision. He leads every recovery plan personally — no rushed handovers, no cookie-cutter protocols.",
  specializations: [
    "Dry Needling (CDNP)",
    "Chiropractic",
    "Manual Therapy (CEOMT)",
    "Dry & Dynamic Cupping Therapy (CDCT)",
    "Kinesiology Taping",
    "MAT Pilates",
  ],
  expertise: [
    "Myofascial Release for muscle tension",
    "Advanced PNF for muscle activation",
    "Neurodynamic techniques for nerve pain",
    "Osteopathy & manual therapy for whole-body balance",
  ],
  awards: [
    {
      title: "University Gold Medalist",
      detail: "Awarded the University Gold Medal in Physiotherapy for academic excellence.",
    },
    {
      title: "Recognised at AIPL 2014",
      detail: "Recognised at the Association of Physiotherapists in Lucknow, 2014.",
    },
    {
      title: "Magh Mela Service Honour, 2017",
      detail:
        "Awarded by the Physiotherapist Welfare Association for free physiotherapy service during Magh Mela 2017.",
    },
  ],
  conferences: [
    "Advanced Treatments and New Trends in Physiotherapy",
    "4th National Physiotherapy Conference",
    "5th National Conference on Diet and Nutrition",
  ],
};

export const IMAGES = {
  drPhoto: {
    src: "/images/dr-vipul-singh.jpg",
    alt: "Dr. Vipul Singh (PT), Chief Consultant Physiotherapist at Kamana Physiotherapy & Rehab Center",
  },
  heroConsult: {
    src: "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Physiotherapist in clinical consultation with a patient at Kamana Physiotherapy, Gomti Nagar",
  },
  rehabStretch: {
    src: "https://images.pexels.com/photos/20860625/pexels-photo-20860625.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "Physiotherapist guiding a patient through targeted lower-limb mobility rehabilitation",
  },
  postureAssess: {
    src: "https://images.unsplash.com/photo-1764314484083-cbd0de7e512c?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Clinical gait and balance assessment at the rehabilitation clinic",
  },
  spineCharts: {
    src: "https://images.unsplash.com/photo-1539815208687-a0f05e15d601?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Spinal anatomy reference used for orthopedic rehabilitation planning",
  },
  treatmentSuite: {
    src: "https://images.pexels.com/photos/7789601/pexels-photo-7789601.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "Private treatment room with modern electro-therapy beds",
  },
  rehabGym: {
    src: "https://images.pexels.com/photos/7789620/pexels-photo-7789620.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "State-of-the-art physiotherapy and therapeutic exercise equipment",
  },
  assistedMobility: {
    src: "https://images.pexels.com/photos/20860622/pexels-photo-20860622.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "Patient performing assisted core and postural balance training",
  },
  legExam: {
    src: "https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Therapist examining a patient's knee joint during assessment",
  },
  dumbbellTherapy: {
    src: "https://images.unsplash.com/photo-1645005513713-9e2b92a687d3?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Strengthening session with light dumbbells under therapist guidance",
  },
  backTherapy: {
    src: "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Hands-on back therapy session for pain relief",
  },
  bandTherapy: {
    src: "https://images.unsplash.com/photo-1645005512942-a17817fb7c11?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Resistance band exercise guided by the rehabilitation team",
  },
};

export const CATEGORIES = [
  {
    id: "pain",
    label: "Pain Management",
    blurb: "Back, neck, joint and nerve pain treated at the root cause — not just masked.",
  },
  {
    id: "sports",
    label: "Sports Rehabilitation",
    blurb: "Return-to-play protocols that get athletes back on the field, stronger.",
  },
  {
    id: "neuro",
    label: "Neuro Rehabilitation",
    blurb: "Stroke, cerebral palsy and facial palsy recovery through motor re-learning.",
  },
  {
    id: "postop",
    label: "Post-Surgical Rehab",
    blurb: "TKR, THR and fracture recovery guided week by week to full strength.",
  },
  {
    id: "advanced",
    label: "Advanced Therapies",
    blurb: "Chiropractic, dry needling, cupping and IASTM by certified hands.",
  },
];

export const TREATMENTS = [
  { name: "Back Pain Treatment", cat: "pain", desc: "Personalised care for muscle strain, posture issues and disc problems — relieve pain, restore mobility and prevent flare-ups." },
  { name: "Neck / Cervical Pain", cat: "pain", desc: "Manual therapy, stretching and strengthening to relieve cervical pain, improve posture and restore full neck mobility." },
  { name: "Sciatica Relief", cat: "pain", desc: "Customised plans that ease nerve pain, reduce inflammation and get you moving comfortably again." },
  { name: "Frozen Shoulder", cat: "pain", desc: "Targeted manual therapy and graded stretches to relieve pain, reduce stiffness and restore shoulder range of motion." },
  { name: "Tennis Elbow", cat: "pain", desc: "Reduce inflammation, promote healing and rebuild strength through targeted exercise and manual therapy." },
  { name: "Ankle Pain / Sprain", cat: "pain", desc: "Restore range of motion and strengthen the ankle to walk, run and move freely without fear of re-injury." },
  { name: "Osteoarthritis", cat: "pain", desc: "Reduce joint pain and stiffness while strengthening the muscles around affected joints — living better without surgery." },
  { name: "Rheumatoid Arthritis", cat: "pain", desc: "Gentle strengthening, joint mobility techniques and pain-management strategies to keep you moving comfortably." },
  { name: "Ankylosing Spondylitis", cat: "pain", desc: "Exercise, manual therapy and posture correction to improve spinal flexibility and overall mobility." },
  { name: "Sports Injury Rehabilitation", cat: "sports", desc: "Sprains, strains and ligament tears treated with sports massage, strength training and injury-prevention drills." },
  { name: "Kinesiology Taping", cat: "sports", desc: "Support and stability for muscles and joints without restricting movement — ideal for sport and training loads." },
  { name: "PNF Stretching", cat: "sports", desc: "Proprioceptive neuromuscular facilitation to rapidly improve flexibility, strength and motor control." },
  { name: "Clinical Pilates", cat: "sports", desc: "Low-impact, therapist-guided Pilates to build core strength, posture and whole-body conditioning." },
  { name: "Stroke Rehabilitation", cat: "neuro", desc: "Neuro-rehabilitation that enhances motor skills, balance and independence after stroke or brain injury." },
  { name: "Cerebral Palsy Rehabilitation", cat: "neuro", desc: "Specialised techniques to improve muscle strength, flexibility, coordination and everyday independence." },
  { name: "Facial Palsy / Bell's Palsy", cat: "neuro", desc: "Facial exercises and neuromuscular re-education to restore facial symmetry, strength and confidence." },
  { name: "Post-Operative Rehab (TKR, THR, Fracture)", cat: "postop", desc: "Structured recovery after knee or hip replacement and fractures — reduce swelling, rebuild strength, return to life sooner." },
  { name: "Post-Fracture Stiffness", cat: "postop", desc: "Gentle stretches, strengthening and joint mobilisations to restore full movement after the cast comes off." },
  { name: "Chiropractic Adjustment", cat: "advanced", desc: "Hands-on spinal realignment to relieve back pain, neck pain, joint issues and headaches at their source." },
  { name: "Cupping Therapy", cat: "advanced", desc: "Dry and dynamic cupping to release muscle tension, improve blood flow and accelerate healing." },
  { name: "Dry Needling", cat: "advanced", desc: "Precision trigger-point release for stubborn muscle knots, chronic pain and sports injuries." },
  { name: "IASTM", cat: "advanced", desc: "Instrument-assisted soft tissue mobilisation to break down scar tissue and speed up recovery." },
  { name: "Advanced Manual Therapy", cat: "advanced", desc: "Hands-on joint and soft-tissue techniques for chronic pain and mobility limitations." },
];

export const TOP_TREATMENTS = [
  "Back Pain Treatment",
  "Sports Injury Rehabilitation",
  "Stroke Rehabilitation",
  "Post-Operative Rehab (TKR, THR, Fracture)",
  "Frozen Shoulder",
  "Dry Needling",
];

export const CONDITION_GROUPS = [
  {
    title: "Back & Neck",
    conditions: ["Slip Disc (PIVD)", "Sciatica", "Cervical Spondylosis", "Back Pain", "Ankylosing Spondylitis"],
  },
  {
    title: "Joint & Knee",
    conditions: ["Osteoarthritis", "Rheumatoid Arthritis", "Frozen Shoulder", "Tennis Elbow", "Ankle Sprain"],
  },
  {
    title: "Neurological",
    conditions: ["Stroke / Paralysis", "Cerebral Palsy", "Bell's Palsy", "Facial Palsy"],
  },
  {
    title: "Post-Operative",
    conditions: ["TKR Rehabilitation", "THR Rehabilitation", "Fracture Stiffness", "ACL Reconstruction"],
  },
];

export const FEATURED_CONDITIONS = [
  { name: "Stroke Rehabilitation", desc: "We help stroke survivors regain mobility, balance and independence through targeted neuro-rehabilitation." },
  { name: "Cerebral Palsy", desc: "Customised pediatric and adult programs improve motor control, flexibility and quality of life." },
  { name: "Frozen Shoulder", desc: "Hands-on therapy and guided exercises restore full shoulder range of motion." },
  { name: "Back & Neck Pain", desc: "Whether from posture, discs or strain, our holistic treatments give long-lasting relief." },
  { name: "Arthritis (OA & RA)", desc: "Tailored exercise, joint protection and manual therapy to manage pain and stiffness." },
  { name: "Sports Injuries", desc: "From ankle sprains to tennis elbow — recover safely and return to peak performance." },
  { name: "Post-Operative Rehab", desc: "Regain strength, mobility and confidence after joint replacements or fractures." },
  { name: "Bell's Palsy", desc: "Neuromuscular retraining to restore facial function and symmetry." },
];

export const PACKAGES = [
  {
    name: "Comprehensive Assessment",
    price: "₹600",
    duration: "45 min",
    tag: "First Visit Recommended",
    features: [
      "Complete orthopedic & postural evaluation",
      "Range of motion & muscle testing",
      "Digital spine alignment review",
      "Customised 3-phase recovery roadmap",
      "First treatment / relief session included",
    ],
  },
  {
    name: "Targeted Pain Relief",
    price: "₹800",
    duration: "Single session · 50 min",
    tag: "Specialized",
    features: [
      "Electro-therapy / ultrasound combination",
      "Manual joint mobilisation & myofascial release",
      "Targeted stretching & core stabilisation",
      "Posture & ergonomic correction protocol",
    ],
  },
  {
    name: "Intensive Rehab Care",
    price: "₹4,800",
    duration: "7-session plan",
    tag: "Most Popular",
    popular: true,
    features: [
      "Dedicated senior therapist assignment",
      "Daily progressive manual therapy",
      "Advanced modalities — laser / IFT / traction",
      "Home exercise program with guidance",
      "Weekly progress audit by Dr. Vipul Singh",
    ],
  },
  {
    name: "Complete Recovery Protocol",
    price: "₹9,500",
    duration: "15 sessions · 3–4 weeks",
    tag: "Comprehensive",
    features: [
      "Ideal for stroke, disc prolapse, post-op TKR",
      "Motor re-learning & gait training",
      "Strength & proprioception retraining",
      "Priority morning / evening slot booking",
      "Free follow-up assessment at 30 days",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Col. R.K. Mishra (Retd.)",
    locality: "Vipin Khand, Gomti Nagar",
    condition: "Lumbar Canal Stenosis & Sciatica",
    quote:
      "After months of excruciating pain and two spine surgeons recommending fusion, Dr. Vipul's decompression and core rehab got me walking pain-free — without surgery.",
    timeframe: "4-week recovery",
  },
  {
    name: "Dr. Sunita Agarwal",
    locality: "Indira Nagar, Lucknow",
    condition: "Frozen Shoulder",
    quote:
      "Being a physician myself, I was impressed by their scientific biomechanical approach. Within 12 sessions, 95% range of motion was restored with zero forceful manipulation.",
    timeframe: "3-week recovery",
  },
  {
    name: "Aman Srivastava",
    locality: "Viram Khand, Gomti Nagar",
    condition: "Post-ACL Reconstruction",
    quote:
      "Kamana Rehab is the best sports clinic in Lucknow. Dr. Vipul guided my agility drills and eccentric strengthening — I'm back on the football pitch with full confidence.",
    timeframe: "10-week protocol",
  },
  {
    name: "Smt. Shanti Devi (71)",
    locality: "Aliganj, Lucknow",
    condition: "Bilateral Knee Osteoarthritis",
    quote:
      "I could barely climb two stairs. Dr. Vipul and his compassionate staff treated me like family. Today I walk independently on my morning temple visits.",
    timeframe: "6-week protocol",
  },
];

export const GALLERY = [
  { ...IMAGES.treatmentSuite, cat: "Treatment Bays" },
  { ...IMAGES.rehabGym, cat: "Rehab Gym" },
  { ...IMAGES.heroConsult, cat: "Clinic Spaces" },
  { ...IMAGES.rehabStretch, cat: "Treatment Bays" },
  { ...IMAGES.assistedMobility, cat: "Rehab Gym" },
  { ...IMAGES.postureAssess, cat: "Diagnostics & Equipment" },
  { ...IMAGES.legExam, cat: "Treatment Bays" },
  { ...IMAGES.dumbbellTherapy, cat: "Rehab Gym" },
  { ...IMAGES.backTherapy, cat: "Treatment Bays" },
  { ...IMAGES.spineCharts, cat: "Diagnostics & Equipment" },
  { ...IMAGES.bandTherapy, cat: "Rehab Gym" },
];

export const MARQUEE_ITEMS = [
  "Spine & Disc Decompression",
  "Sports Injury Return-to-Play",
  "Post-Stroke Neuro Rehabilitation",
  "Knee & Hip Replacement Protocol",
  "Cervical & Lumbar Spondylosis",
  "Dry Needling & Cupping Therapy",
  "Laser & Electro-Therapy",
  "Pediatric & Geriatric Mobility Care",
];

export const ARTICLES = [
  {
    id: "desk-posture",
    tag: "Posture",
    readTime: "3 min read",
    title: "The 90-Minute Rule: Fixing Desk Posture Before It Fixes Your Spine",
    excerpt:
      "Your neck doesn't hurt because of one bad day — it hurts because of nine hundred small ones. Here's the routine our Gomti Nagar clinic prescribes.",
    body: [
      "Every second patient who walks into our Gomti Nagar clinic with neck or lower back pain works at a desk. The pattern is remarkably consistent: the head drifts forward an inch for every hour of focus, the shoulders roll in, and the lumbar curve quietly disappears.",
      "We prescribe the 90-minute rule. Every 90 minutes, stand up and perform 10 slow chin tucks, 10 shoulder blade squeezes and 5 standing back extensions. It takes under two minutes and interrupts the exact mechanism that builds cervical and lumbar strain.",
      "Then, set your screen so the top third is at eye level and your elbows rest at 90 degrees. If you already wake up stiff, a single assessment session can identify which of your postural muscles have switched off — and a short, targeted program can switch them back on.",
    ],
  },
  {
    id: "morning-spine",
    tag: "Spine Care",
    readTime: "4 min read",
    title: "Why Your Back Hurts Most in the Morning — and What to Do About It",
    excerpt:
      "Morning stiffness that melts in 30 minutes is a message from your spine. Learn to read it, and move with it instead of against it.",
    body: [
      "Overnight, spinal discs rehydrate and gently expand. That's normal — but in a stiff or deconditioned spine it makes the first movements of the day genuinely uncomfortable. If your back eases within 30 minutes of waking, your spine is asking for mobility, not rest.",
      "Start before your feet touch the floor: lying knee rolls, 10 to each side, slow. Then cat–cow stretches for one minute, and finish with a brisk five-minute walk before breakfast.",
      "Morning stiffness lasting more than an hour, every day, deserves a professional look. It can be an early sign of inflammatory back conditions like ankylosing spondylitis — the earlier it's managed, the better the outcome.",
    ],
  },
  {
    id: "knee-care",
    tag: "Joint Health",
    readTime: "3 min read",
    title: "Climbing Stairs Shouldn't Be a Negotiation: Everyday Knee Care",
    excerpt:
      "Knee osteoarthritis doesn't demand that you stop moving — it demands that you move differently. Three principles we teach every knee patient.",
    body: [
      "The first thing we tell knee patients surprises them: rest makes arthritis stiffer, not better. Cartilage has no blood supply — it feeds on movement, like a sponge that needs squeezing to stay healthy.",
      "Principle one: strong thighs are the knee's shock absorbers. Sit-to-stand squats and short arch-strength routines beat any brace. Principle two: respect the 24-hour rule — if a day's activity leaves the knee more swollen the next morning, scale back, don't stop. Principle three: keep walking surfaces varied; flat, predictable corridors lull the knee into weakness.",
      "If stairs have become a negotiation, a structured six-week program of strengthening and manual therapy usually rewrites the terms.",
    ],
  },
  {
    id: "sports-comeback",
    tag: "Sports Rehab",
    readTime: "4 min read",
    title: "Return to Play: Why the Last 20% of Rehab Is the Most Important",
    excerpt:
      "Most re-injuries happen after the pain stops — because the athlete stopped rehabbing too. The science of finishing what you started.",
    body: [
      "Pain is a poor progress report. By the time a ligament or muscle stops hurting, it has typically regained barely half its strength and none of its reactive protection. That's why the last phase of sports rehab — strength symmetry, jumping, landing, cutting — is the part that decides whether you stay on the field.",
      "Our return-to-play protocol measures symmetry: the injured side must reach at least 90% of the healthy side on strength and hop tests before full training resumes.",
      "It adds two or three weeks to the calendar and takes years off your risk. The athletes we've guided through ACL, ankle and hamstring rehab will tell you the same thing: the boring last phase is the one that kept them playing.",
    ],
  },
];

export const WHY_CHOOSE = [
  { title: "Experienced & Certified", desc: "University Gold Medalist-led care with internationally certified specialisations." },
  { title: "Advanced Techniques", desc: "Dry needling, chiropractic, cupping, IASTM and laser — all under one roof." },
  { title: "Personalised Plans", desc: "Every recovery roadmap is built for your body, your condition and your goals." },
  { title: "Evidence-Based", desc: "Protocols grounded in current clinical research, audited week by week." },
  { title: "One-on-One Sessions", desc: "Full 45–60 minute undivided sessions — zero rush, zero assembly line." },
  { title: "Open 7 Days", desc: "Mon–Sat 9 AM–9 PM and Sunday mornings, because pain doesn't keep office hours." },
];

export const STATS = [
  { value: "23+", label: "Specialised Treatments" },
  { value: "Gold", label: "Medalist Leadership" },
  { value: "45–60", label: "Min One-on-One Sessions" },
  { value: "7 Days", label: "Open Every Week" },
];
